import { compose, curry } from 'ramda';
import warning from 'warning';

import envConfig from '../../../env-config.json';

const resolveProfileName = () => {
  const explicit = process.env.NX_SERVER;
  if (explicit && envConfig?.[explicit]) return explicit;

  const hostname = window?.location?.hostname;
  if (hostname && envConfig?.[hostname]) return hostname;

  if (hostname?.includes('localhost') || hostname === '127.0.0.1') return 'localhost';
  if (hostname?.includes('develop')) return 'develop';
  if (hostname?.includes('staging')) return 'staging';
  return 'main';
};

const getFromConfig = (key) => {
  const profile = resolveProfileName();
  return envConfig?.[profile]?.[key];
};

const get = (envName) => {
  const envValue = process.env[`NX_${envName}`];
  if (typeof envValue !== 'undefined') return envValue;

  const configValue = getFromConfig(`NX_${envName}`);
  warning(
    typeof configValue !== 'undefined',
    `there's no "NX_${envName}" environment and no env-config.json fallback for profile "${resolveProfileName()}"`,
  );
  return configValue;
};

const getServer = () => get('SERVER') || 'localhost';
const checkServer = curry((checkedServer, server) => server === checkedServer);

const isServerLocalhost = compose(checkServer('localhost'), getServer);
const isServerDev = compose(checkServer('development'), getServer);
const isServerStaging = compose(checkServer('staging'), getServer);
const isServerProduction = compose(checkServer('production'), getServer);

const getAPIUrl = () => get('API_URL');

export default {
  get,
  isServerLocalhost,
  isServerDev,
  isServerStaging,
  isServerProduction,
  getAPIUrl,
  getServer,
};
